import { HOME_PAGE, createUppPath } from '#src/utils';

import { UseShoppingBasketPaymentPageType } from './useShoppingBasketPaymentPage.types';

const composeOptionalUrlParams = (optionalParams) =>
  Object.entries(optionalParams)
    .map(([key, value]) => {
      if (key === 'onFailureRedirectPath') {
        return `${key}=${encodeURIComponent(value as string)}`;
      }
      return `${key}=${value}`;
    })
    .join('/');

const format = (data: UseShoppingBasketPaymentPageType) => {
  const { onSuccessUrl, optionalUrlParams } = data || {};
  const shoppingBasketToken = data.shoppingBasketToken as string;
  const additionalParams = optionalUrlParams
    ? `${composeOptionalUrlParams(optionalUrlParams)}`
    : '';

  return createUppPath(
    shoppingBasketToken,
    onSuccessUrl ?? HOME_PAGE,
    additionalParams
  );
};

export const formatUrl = (data: UseShoppingBasketPaymentPageType) =>
  format(data);

export const isACompleteUrl = (url: string) => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};
